<template>
    <div class="permission-container" v-if="hasPermission || showTip">
        <slot v-if="hasPermission"></slot>
        <div v-if="!hasPermission && showTip" class="permission-tip">{{tip}}</div>
    </div>
</template>

<script>
export default {
    name: "PermissionContainer",
    props: {
        permissionId: String,
        permissionIds: {
            type: Array,
            default() {
                return [];
            }
        },
        tip: {
            type: String,
            default: '您没有权限'
        },
        // permissionGroupId: String,
        showTip: {
            type: Boolean,
            default: false
        }
    },
    data()
    {
        return {
            // hasPermission: false
        }
    },
    beforeMount()
    {
        // if(!this.permissionId && !this.permissionGroupId)
        // {
        //     return this.hasPermission = true;
        // }
        // this.hasPermission = (this.$store.state.session.userPermissionIdList.indexOf(this.permissionId)>=0
        //     || this.$store.state.session.userPermissionGroupIdList.indexOf(this.permissionGroupId) >= 0);
    },
    computed: {
        hasPermission() {
            if (!this.permissionId && !this.permissionIds.length)
                return true;
            if (this.permissionId)
                return this.$store.state.session.userPermissionIdList.indexOf(this.permissionId)>=0;
            for (let permissionId of this.permissionIds) {
                if (this.$store.state.session.userPermissionIdList.indexOf(permissionId)>=0)
                    return true;
            }
            return false;
        }
    },
    watch:
    {
        // permissionId: function(val, oldVal)
        // {
        //     if(!this.permissionId && !this.permissionGroupId)
        //     {
        //         return this.hasPermission = true;
        //     }
        //     this.hasPermission = (this.$store.state.session.userPermissionIdList.indexOf(this.permissionId)>=0
        //         || this.$store.state.session.userPermissionGroupIdList.indexOf(this.permissionGroupId) >= 0);
        // },
        // permissionGroupId: function(val, oldVal)
        // {
        //     if(!this.permissionId && !this.permissionGroupId)
        //     {
        //         return this.hasPermission = true;
        //     }
        //     this.hasPermission = (this.$store.state.session.userPermissionIdList.indexOf(this.permissionId)>=0
        //         || this.$store.state.session.userPermissionGroupIdList.indexOf(this.permissionGroupId) >= 0);
        // }
    }

}
</script>

<style scoped>
.permission-container
{
    display: inline;
    flex: 1;
}
.permission-tip {
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/container/PermissionContainer.vue